import { ButtonBase, makeStyles } from '@material-ui/core';
import { classNames } from '../../utils';

const useStyle = makeStyles(() => ({
  icon: ({ text }) => ({
    width: '1.5rem',
    height: '1.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: text ? '0.3rem' : '',
  }),
  exportBtn: ({ borderRadius, border, backgroundColor, width, minWidth, height, type, m, p, disabled }) => ({
    width: width ?? '6.875rem',
    minWidth: minWidth,
    height: height ?? '3rem',
    borderRadius: borderRadius ?? '10px',
    border: border ?? (type === 'fill' ? 'none' : 'solid 1px #538fff'),
    backgroundColor: backgroundColor ?? (type === 'fill' ? '#538fff' : '#f5faff'),
    margin: m,
    padding: p,
    ...(disabled ? { backgroundColor: '#c0c6cb' } : {}),
  }),
  exportIcon: ({ iconStyle, type, disabled }) => ({
    fontSize: '1.25rem',
    color: type === 'fill' ? '#ffffff' : '#538fff',
    ...iconStyle,
  }),
  text: ({ fontStyle, color, type }) => ({
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: color ?? (type === 'fill' ? '#ffffff' : '#538fff'),
    ...fontStyle,
  }),
  disabledText: ({ disabledTextColor }) => ({
    color: disabledTextColor ?? '#fff',
  }),
}));

// type: default , fill
const StyleButton = ({
  id,
  Icon,
  text,
  iconStyle,
  fontStyle,
  onClick,
  borderRadius,
  border,
  backgroundColor,
  width,
  minWidth,
  height,
  className,
  m,
  p,
  color,
  disabled = false,
  type = 'default',
  disabledTextColor,
}) => {
  const classes = useStyle({
    iconStyle,
    fontStyle,
    borderRadius,
    border,
    backgroundColor,
    width,
    minWidth,
    height,
    type,
    m,
    p,
    color,
    text,
    disabled,
    disabledTextColor,
  });

  return (
    <ButtonBase className={classNames(classes.exportBtn, className)} id={id} onClick={onClick} disabled={disabled}>
      {typeof Icon === 'function' && (
        <div className={classes.icon}>
          <Icon className={classes.exportIcon} />
        </div>
      )}
      {text && <div className={classNames(classes.text, disabled && classes.disabledText)}>{text}</div>}
    </ButtonBase>
  );
};

export default StyleButton;
